import React from 'react';
import { SxProps } from '@mui/system';
import {
    SignalCellular0BarRounded as SignalCellular0BarW200,
    SignalCellular1BarRounded as SignalCellular1BarW200,
    SignalCellular2BarRounded as SignalCellular2BarW200,
    SignalCellular3BarRounded as SignalCellular3BarW200,
    SignalCellular4BarRounded as SignalCellular4BarW200,
    SignalCellularNodataRounded as SignalCellularNodataW200,
} from '@mui-symbols-material/w200';
import {
    SignalCellular0BarRounded as SignalCellular0BarW300,
    SignalCellular1BarRounded as SignalCellular1BarW300,
    SignalCellular2BarRounded as SignalCellular2BarW300,
    SignalCellular3BarRounded as SignalCellular3BarW300,
    SignalCellular4BarRounded as SignalCellular4BarW300,
    SignalCellularNodataRounded as SignalCellularNodataW300,
} from '@mui-symbols-material/w300';

const DEFAULT_COLOR = '#666666';
const LARGE_SIZE_THRESHOLD = 36;

interface Props {
    signalStrength: number | null | undefined;
    size?: number;
    sx?: SxProps;
}

const pickIcon = (signalStrength: number | null | undefined, large: boolean) => {
    if (signalStrength == null) {
        return large ? SignalCellularNodataW200 : SignalCellularNodataW300;
    }
    if (signalStrength >= 4) {
        return large ? SignalCellular4BarW200 : SignalCellular4BarW300;
    }
    if (signalStrength === 3) {
        return large ? SignalCellular3BarW200 : SignalCellular3BarW300;
    }
    if (signalStrength === 2) {
        return large ? SignalCellular2BarW200 : SignalCellular2BarW300;
    }
    if (signalStrength === 1) {
        return large ? SignalCellular1BarW200 : SignalCellular1BarW300;
    }
    return large ? SignalCellular0BarW200 : SignalCellular0BarW300;
};

const SignalStrengthIcon = ({ signalStrength, size = 24, sx }: Props) => {
    const large = size > LARGE_SIZE_THRESHOLD;
    const Icon = pickIcon(signalStrength, large);

    return (
        <Icon
            sx={{ fontSize: `${size}px`, color: DEFAULT_COLOR, ...(sx as object) }}
        />
    );
};

export default SignalStrengthIcon;
